/**
 * 全局权限判断混入
 * 用法：v-if="$hasPerm('purchase:confirm')" 或 this.$hasPerm('purchase:confirm')
 */
export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        $hasPerm(identifier) {
          if (!identifier) return true
          return this.$store.state.perms.includes(identifier)
        }
      }
    })
  }
}
